"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@seneca/errors");
/**
 * Thrown when clock skew cannot be fixed, resulting in server blocking requests
 */
class UnrectifiableClockSkewError extends errors_1.ExtendableError {
    constructor({ reason, correlationId }) {
        super(reason);
        this.correlationId = correlationId;
    }
}
exports.default = UnrectifiableClockSkewError;
